import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=496b382b&scoped=true"
import script from "./couponDetail.vue?vue&type=script&lang=js"
export * from "./couponDetail.vue?vue&type=script&lang=js"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=496b382b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496b382b",
  null
  
)

export default component.exports